import { useEffect } from 'react';

import { isEmptyCollection, useSportsbookState } from '@atlas/core';

import { useSimplifiedSportsbook } from 'common/SimplifiedSportsbook/SimplifiedSportsbookContext';

export const searchQueryName = 'q';

const SimplifiedSelectedSportProvider = ({ children }) => {
  const { selectedSportUrlName, sports } = useSportsbookState();
  const { setSportName, sportName } = useSimplifiedSportsbook();

  useEffect(() => {
    if (selectedSportUrlName) {
      setSportName(selectedSportUrlName);
    }

    if (!sportName && !isEmptyCollection(sports)) {
      setSportName(sports[0].name);
    }
  }, [setSportName, sportName, sports]);

  return children;
};

export default SimplifiedSelectedSportProvider;
